import salesOrderApi from '@/services/API/sales-order'
import invoiceApi from '@/services/API/invoice'
import packageApi from '@/services/API/package'
import salesUtils from '@/utils/sales-utils'
import { MessageBox, Message } from 'element-ui';
import salesAPI from '@/services/API/sales'


import i18n from '../../../i18n';

//WARNING => DUPLCATED IN SalesOrderEditor
const actionsMap = {
  save: {
    associatedStatus: 'DRAFT'
  },
  emit : {
    associatedStatus : 'TO_PROCESS'
  },
  process : {
    associatedStatus : 'IN_PROCESS'
  },
  confirm: {
    associatedStatus: 'CONFIRMED'
  },
  cancel : {
    associatedStatus: 'VOIDED'
  },
  returnDraft : {
    associatedStatus: 'DRAFT'
  },
  charge : {
    associatedStatus: 'WAITING_PAYMENT'
  },
  confirmSAQ : {
    associatedStatus: 'CONFIRMED_SAQ'
  }
};

/**
 * Get the status of the sales order depending on the action executed.
 * The worklfow is:
 * NONE -> draft -> confirmed -> (invoiced | packed | shipped) -> fullfiled -> closed
 * @param {String} action
 * @param {Object} salesOrderStatuses
 * @param {Object} salesOrder
 */
function getStatusFromAction(action, salesOrderStatuses, salesOrder) {
  const saveStatus = salesOrder.status==null?salesOrderStatuses.find(s => s.code === 'DRAFT') : salesOrder.status;
  return action==='save' ? saveStatus : salesOrderStatuses.find(s => s.code === actionsMap[action].associatedStatus);
}

const initSalesOrders = function({commit}){
  //Ajout des statuts custom
  if(localStorage.SALES_ORDER_CUSTOM_STATUS!=null){
    _.forEach(JSON.parse(localStorage.SALES_ORDER_CUSTOM_STATUS), customStatus=>{
      actionsMap[customStatus.action]=customStatus.actionsMap[customStatus.action];
    })
  }
}

const invalidateSalesOrderList = function ({ commit }) {
  commit('INVALIDATE_LIST');
}

const changePage = function({commit, dispatch}, page) {
  commit('SET_PAGE', page);
  dispatch('invalidateSalesOrderList');
  dispatch('fetchSalesOrders')
}

const fetchNextPage = function({commit, state, dispatch}) {
  if (state.page < state.pages) {
    commit('SET_PAGE', state.page + 1);
    dispatch('invalidateSalesOrderList');
    dispatch('fetchSalesOrders');
  }
}

const fetchPreviousPage = function({commit, state, dispatch}) {
  if (state.page > 1) {
    commit('SET_PAGE', state.page - 1);
    dispatch('invalidateSalesOrderList');
    dispatch('fetchSalesOrders');
  }
}

//Fetch customer based on a search string
const fetchSalesOrders = function({ commit, state, getters }) {
  if(state.outDated){

    let params = getters.fetchParams;

    commit('SET_LOADING', true);
    return salesOrderApi.fetchSalesOrders(params, ['customer', 'productInventoryQuantity', 'contact']).then(salesOrders => {
      commit('SET_SALES_ORDERS', salesOrders.list);
      if(salesOrders.count){
        commit('SET_COUNT', salesOrders.count );
        commit('SET_PAGES', salesOrders.pages );
        commit('SET_PAGE', salesOrders.page);
      } else {
        commit('SET_COUNT', 0);
        commit('SET_PAGES', 0 );
      }
      commit('SET_LOADING', false);
    });
  }
};

const changeOrderBy = function({commit, state, dispatch}, {orderName, direction}){
  commit('SET_ORDERNAME_AND_DIRECTION', {orderName, direction});
  dispatch('invalidateSalesOrderList');
  dispatch('fetchSalesOrders');
}

const changeSortIcon = function({commit},icon){
  commit('SET_SORT_ICON',icon);
}

let searchTimeOut = null;
const setSearchTerms = function({commit, dispatch}, searchTerms) {
  commit('SET_SEARCH_TERMS',searchTerms);
  commit('SET_PAGE', 1);
  commit('SET_LOADING', true);
  clearTimeout(searchTimeOut)
  searchTimeOut = setTimeout(() => {
    dispatch('invalidateSalesOrderList');
    dispatch('fetchSalesOrders');
  }, 500)

}

const selectSalesOrder = function({commit, state, dispatch}, {salesOrderId, index}){
  commit('SET_SALES_ORDER_LOADING', true);
  return salesOrderApi.getSalesOrderV2(salesOrderId)
    .then(salesOrder=>{
        salesOrder.invalid = false;
        //Si nous sommes en DRAFT on prend le dernier calcul des items et on ajoute des attributs
        //    pour afficher les anciennces valeurs
        // if(salesOrder.status.code=="DRAFT" && salesOrder.calculation_detail!=null){
        //   if(salesOrder.total.toFixed(2)!=salesOrder.calculation_detail.total.toFixed(2)){
        //     salesOrder.invalid = true;
        //     salesOrder.old_sub_total = salesOrder.sub_total;
        //     salesOrder.sub_total = salesOrder.calculation_detail.sub_total;
        //     salesOrder.old_total = salesOrder.total;
        //     salesOrder.total = salesOrder.calculation_detail.total;
        //
        //
        //     salesOrder.items = salesOrder.calculation_detail.items;
        //   }else{
        //     salesOrder.items = salesOrder.calculation_detail.items;
        //   }
        // }

        commit('SET_SELECTED_SALES_ORDER', salesOrder);
        commit('SET_SELECTED_INDEX', index);
        commit('SET_SALES_ORDER_LOADING', false);
        // commit('BUILD_HISTORIC_ACTIVITIES');
        dispatch('setSelectedSalesOrder', salesOrder);
    })
}

const markAs = function({rootState, commit, state, dispatch}, action) {
  let status = getStatusFromAction(action, rootState.statuses.salesOrderStatuses,state.selectedSalesOrder);
  let so = _.cloneDeep(state.selectedSalesOrder);
  let error = false;
  so.status = status;
  so.fk_status_id = status.id;

  if(action=="emit"){
    if(state.selectedSalesOrder.date==null){
      Message.error('Vous devez saisir une date de commande.');
      error = true;
    }
    if(state.selectedSalesOrder.items.length==0){
      Message.error('Impossible de confirmer la commande. Veuillez ajouter des items.');
      error = true;
    }
  }

  if(!error){
    return salesOrderApi.putSalesOrderV2(state.selectedSalesOrder.id, {fk_status_id:status.id, status})
      .then(salesOrder=>{
        commit('SET_STATUS',status);
        commit('SET_SELECTED_SALES_ORDER', salesOrder);
        commit('SET_PACKAGES', salesOrder.packages);
        commit('BUILD_HISTORIC_ACTIVITIES');
        dispatch('stockItems/invalidateStockItems',null,{root:true});
      })
  }
}

const markAsCompleted = function({rootState, commit, state, dispatch, getters}) {
  return salesOrderApi.completeSales(state.selectedSalesOrder.id)
      .then(salesOrder=>{
        Message.success('Commande complétée');
        commit('SET_STATUS', salesOrder.status);
      }).catch(err=>{
         //Custom error
         Message.error(i18n.t('sales_orders.errors.'+err.response.data.jse_info.errorCode));
        return dispatch('selectSalesOrder', { salesOrderId: state.selectedSalesOrder.id });
      })
}

const markAsConfirmed = function({rootState, commit, state, dispatch, getters}) {
  let validObject = salesUtils.validateSalesOrder(state.selectedSalesOrder, {date:true, items:true,quantities:true,delivery:true,billingContact:true,shippingContact:true})

  let valid = true;
  _.forIn(validObject, (value, key) => { if(!value)valid=false; })

  if(valid){
    return salesOrderApi.confirmSales(state.selectedSalesOrder.id)
      .then(salesOrder=>{
        Message.success('Commande confirmée');
        commit('SET_STATUS', salesOrder.status);
        commit('SET_PACKAGES', salesOrder.packages);
      }).catch(err=>{
        if (_.get(err.response.data, 'errorCode') === 'PRODUCT_NOT_AVAILABLE_QUANTITY') {
          Message.error(i18n.t('sales_orders.errors.'+_.get(err.response.data, 'errorCode')));
        } else {
          //Custom error
          Message.error(i18n.t('sales_orders.errors.'+err.response.data.jse_info.errorCode));
        }
        return dispatch('selectSalesOrder', { salesOrderId: state.selectedSalesOrder.id });
      })
  } else {
    Message.error("Le bon de commande n'est pas valide.");
  }

}

const markAsInProcess= function({rootState, commit, state, dispatch}) {
  dispatch('markAs','process');

}

const markAsDraft = function({dispatch, state, commit}){
  MessageBox.confirm('Voulez-vous vraiment remettre la commande en brouillon? Ceci remettra les articles en inventaire.',"Remettre la commande en brouillon",{
    confirmButtonText: 'Oui',
    cancelButtonText: 'Annuler'
  }).then(()=>{
    return salesOrderApi.declineSalesV2(state.selectedSalesOrder.id)
      .then(salesOrder=>{
        commit('SET_STATUS', salesOrder.status);
        commit('SET_PACKAGES', salesOrder.packages);
      }).catch(err=>{
        console.log(err);
      })
  }).catch((err)=>{/*do nothing*/})
}



const markAsVoided = function({dispatch, state, commit}) {
  MessageBox.confirm('Voulez-vous vraiment annuler la commande?',"Annluation d'une commande",{
    confirmButtonText: 'Oui',
    cancelButtonText: 'Annuler'
  }).then(()=>{
      return salesOrderApi.voidSalesV2(state.selectedSalesOrder.id)
        .then((salesOrder) => {
          commit('SET_STATUS',salesOrder.status);
          commit('SET_PACKAGES', salesOrder.packages);
        }).catch(err=>{
          if (err.response.status === 409) {
            MessageBox.confirm('Il y a des factures actives associées à la commande. Voulez-vous tout de même annuler la commande?',"Annluation d'une commande",{
              confirmButtonText: 'Oui',
              cancelButtonText: 'Annuler'
            }).then(()=> {
              return salesOrderApi.voidSalesV2(state.selectedSalesOrder.id, true)
                .then((salesOrder) => {
                  commit('SET_STATUS',salesOrder.status);
                  commit('SET_PACKAGES', salesOrder.packages);
                }).catch((err) => {
                  Message.error('Une erreur est survenue. Veuillez réessayer plus tard.')
                })
            }).catch(() => { /* do nothing */ })
          }
        })
  }).catch((err)=>{console.log(err);/* do nothing */})
}


const setSelectedSalesOrder = function({commit, state, dispatch}, salesOrder){
    commit('CLONE_TO_SELECTED_SALES_ORDER',salesOrder);
}

const deleteSelectedSalesOrder = function ({commit, state, dispatch}){
  // console.log("deleteSelectedSalesOrder");
  return MessageBox.confirm("Voulez-vous vraiment supprimer cette commande? La suppression sera irreversible!","Suppression d'une commande",{
    confirmButtonText: 'Oui',
    cancelButtonText: 'Annuler'
  }).then(()=>{
    return salesOrderApi.deleteSalesOrderV2(state.selectedSalesOrder.id)
      .then(()=>{
        if(state.selectedIndex!=null){
          commit('DELETE_SELECTED_SALES_ORDER');
        }else{
          dispatch('invalidateSalesOrderList');
        }
        return true;
      }).catch(err=>{
        Message.error(i18n.t('sales_orders.errors.'+err.response.data.errorCode));
        return false;
      })
  }).catch(err=>{return false })

}



const processSalesOrder = function({commit, state, rootState, dispatch, getters}, automatic){

  if (_.get(state, 'selectedSalesOrder.deliveryType.invalidLocation') === true) {
    Message.error(i18n.t('sales_orders.errors.INVALID_LOCATION'));
  } else {
    if (getters.isSelectedSalesOrderQuantitiesValid) {
      return salesOrderApi.processV2(state.selectedSalesOrder.id, automatic)
        .then(salesOrder=>{
          commit('SET_STATUS', salesOrder.status);
          commit('SET_PACKAGES', salesOrder.packages);
        }).catch((err) => {
          if (_.get(err, 'response.data') != null) {
            MessageBox.confirm(i18n.t(`sales_orders.errors.${_.get(err, 'response.data.errorCode')}`), i18n.t('common.Warning'), {
            confirmButtonText: i18n.t('common.Refresh'),
            cancelButtonText: i18n.t('common.Cancel'),
            type: 'warning'
          }).then(() => {
            dispatch('selectSalesOrder', { salesOrderId: _.get(state, 'selectedSalesOrder.id')});
          }).catch(() => {
            //do nothing
          });
          } else {
            Message.error(i18n.t('sales_orders.errors.'+err.response.data.jse_info.errorCode));
            return dispatch('selectSalesOrder', { salesOrderId: state.selectedSalesOrder.id });
          }
        })
    } else {
      Message.error(i18n.t('sales_orders.errors.PRODUCT_NOT_AVAILABLE_QUANTITY'));
    }
  }
}
const downloadSalesOrderReport = function({commit,state}, {salesOrder, type}){


  commit('SET_REPORT_DOWNLOADING',true);
  const salesOrderInfo = salesOrder ? salesOrder : state.selectedSalesOrder;
  let salesOrderId = salesOrderInfo.id;
  let salesOrderNumber = salesOrderInfo.soNumber;
  let error = false;

  if(salesOrderInfo.date==null){
    Message.error('Vous devez spécifier une date de commande.');
    error = true;
  }

  let filename = salesOrderNumber;
  if(type=="PDF"){
    filename+=".pdf";
    if(!error){
      salesOrderApi.downloadSalesOrderReportV2(salesOrderId, filename,{type})
        .then(()=>{
          commit('SET_REPORT_DOWNLOADING',false);
        })
    }
  }else{
    let packageInfo = _.head(salesOrder.packages);
    filename = packageInfo.agencyNumber === 'DEFAULT' ? `${salesOrderNumber}-${packageInfo.pkNumber}.xlsx` : `${salesOrderNumber}-${packageInfo.pkNumber}-${packageInfo.agencyNumber}.xlsx`
    if(salesOrderInfo.deliveryType==null){
      Message.error('Veuillez spécifier un type de livraison.');
      error = true;
    }
    if (!error) {
      packageApi.getReport(packageInfo.id, { format: 'CSV' }, filename)
      .then(()=>{
        commit('SET_REPORT_DOWNLOADING',false);
      })
    }

  }
}

const changeCustomerClassFilter = function({commit, dispatch}, checkedCustomerClasses){
  commit('CHANGE_CHECKED_CUSTOMER_CLASSES_FILTER', checkedCustomerClasses);
  commit('SET_PAGE', 1);
  dispatch('invalidateSalesOrderList');
  dispatch('fetchSalesOrders');
}

const setStatusFilters = function({commit, dispatch}, statusFilter){
  commit('SET_STATUS_FILTER', statusFilter);
  commit('SET_PAGE', 1);
  dispatch('invalidateSalesOrderList');
  dispatch('fetchSalesOrders');
}

const setDateFilters = function({commit, dispatch}, dateFilter){
  commit('SET_DATE_FILTER', dateFilter);
  commit('SET_PAGE', 1);
  dispatch('invalidateSalesOrderList');
  dispatch('fetchSalesOrders');
}

const setDeliveryDateFilters = function({commit, dispatch}, deliveryDateFilter){
  commit('SET_DELIVERY_DATE_FILTER', deliveryDateFilter);
  commit('SET_PAGE', 1);
  dispatch('invalidateSalesOrderList');
  dispatch('fetchSalesOrders');
}

const resetFilters = function({commit, dispatch}, event){
  if(event != null) {
    event.stopPropagation();
  }
  commit('RESET_FILTERS');
  dispatch('invalidateSalesOrderList');
  dispatch('fetchSalesOrders');
}

const confirmSAQ = function({state, dispatch, rootState}, salesOrderId) {
  MessageBox.prompt(i18n.t('sales_orders.EnterExternalSONumber'),i18n.t('sales_orders.OrderConfirmation'),{
    confirmButtonText: i18n.t('common.ok'),
    cancelButtonText: i18n.t('common.Cancel')
  }).then(({value})=>{
    let status = getStatusFromAction('confirmSAQ', rootState.statuses.salesOrderStatuses,state.selectedSalesOrder);
    salesOrderApi.putSalesOrderV2(salesOrderId,{reference:value, status})
      .then(salesOrder=>{
        dispatch('setSelectedSalesOrder', salesOrder);
      }).catch(err=>{Message.error('Une erreur système est survenue. Veuillez réessayer plus tard.')})
  })
  .catch(err=>{
    console.log(err);
  })
}

const updateCustomStatus = function({state, dispatch, rootState},{customStatus, salesOrderId}){
  // console.log(customStatus.action)
  if(customStatus.action === "confirmSAQ"){
    MessageBox.prompt(i18n.t('sales_orders.EnterExternalSONumber'),i18n.t('sales_orders.OrderConfirmation'),{
      confirmButtonText: i18n.t('common.ok'),
      cancelButtonText: i18n.t('common.Cancel')
    }).then(({value})=>{
      const packageId = _.get(_.head(state.selectedSalesOrder.packages), 'id');
      packageApi.confirm(packageId, value)
        .then(() => {
          dispatch('selectSalesOrder', {salesOrderId : state.selectedSalesOrder.id, index:state.selectedIndex});
        })
        .catch((err)=>{
          console.log(err);
          Message.error('Une erreur système est survenue. Veuillez réessayer plus tard.')
        })
    }).catch(err=>{
      console.log(err);
    })
  } else if(customStatus.action === "reject"){
    let status = getStatusFromAction(customStatus.action, rootState.statuses.salesOrderStatuses,state.selectedSalesOrder);
    salesOrderApi.putAction(salesOrderId, 'REJECTED', { status })
    // salesOrderApi.putSalesOrderV2(salesOrderId, {reference:value, status, action: customStatus.action})
      .then(salesOrder=>{
        dispatch('setSelectedSalesOrder', salesOrder);
      }).catch(err=>{Message.error('Une erreur système est survenue. Veuillez réessayer plus tard.')})
  } else{
    if(customStatus.confirmation){
      MessageBox.confirm(customStatus.confirmation.text,customStatus.confirmation.title,{
        confirmButtonText: 'Oui',
        cancelButtonText: 'Annuler'
      }).then(({value})=>{
        if(state.selectedSalesOrder.packages!=null){
          packageApi.delete(state.selectedSalesOrder.packages[0].id)
            .then(()=>{dispatch('markAs',customStatus.action)})
            .catch(err=>{Message.error('Une erreur système est survenue. Veuillez réessayer plus tard.')})
        }else{
          dispatch('markAs',customStatus.action)
        }

      }).catch(err=>{})
    }else{
      dispatch('markAs',customStatus.action)
    }

  }
}

const setCheckedTagsFilter = function({state, commit, dispatch}, tags){
  commit('SET_CHECKED_TAGS_FILTER', tags);
  commit('SET_PAGE', 1);
  dispatch('invalidateSalesOrderList');
  dispatch('fetchSalesOrders');
}



const returnAsConfirmed = function({state, commit, dispatch}){
  MessageBox.confirm('Êtes vous sur de vouloir remettre le statut de la commande à "À traiter"? Ceci libérera les items en inventaire.',"Changement de statut",{
    confirmButtonText: 'Oui',
    cancelButtonText: 'Annuler'
  }).then(()=>{
    salesOrderApi.unProcessSalesV2(state.selectedSalesOrder.id)
      .then(salesOrder=>{
        dispatch('setSelectedSalesOrder', salesOrder);
      })
  }).catch(err=>{
    if(err==="cancel"){
      Message.success("Le statut de la commande n'a pas été modifié.");
    }
  })


}

const setCheckedReps = function({commit, dispatch}, checkedReps){
  commit('SET_CHECKED_REPS', checkedReps);
  dispatch('invalidateSalesOrderList');
  dispatch('fetchSalesOrders');
}

const setFilterWithoutReps = function({commit, dispatch}, withoutReps){
  commit('SET_WITHOUT_REPS_FILTER', withoutReps);
  commit('SET_PAGE', 1);
  dispatch('invalidateSalesOrderList');
  dispatch('fetchSalesOrders');
}

const setCustomerFilter = function({commit, dispatch}, customer){
  commit('SET_FILTER_CUSTOMER_ID', customer.id);
  commit('SET_PAGE', 1);
  dispatch('invalidateSalesOrderList');
  dispatch('fetchSalesOrders')
}
const setInventoryFilter = function({commit, dispatch}, inventories){
  commit('SET_FILTER_INVENTORY_FILTER', inventories);
  commit('SET_PAGE', 1);
  dispatch('invalidateSalesOrderList');
  dispatch('fetchSalesOrders')
}

const setProductFilter = function({commit, dispatch}, product){
  commit('SET_FILTER_PRODUCT_ID', product.id);
  commit('SET_PAGE', 1);
  dispatch('invalidateSalesOrderList');
  dispatch('fetchSalesOrders')
}

const setDeliveryTypeFilter = function({commit, dispatch}, deliveryType) {
  commit('SET_FILTER_DELIVERY_TYPE', deliveryType);
  commit('SET_PAGE', 1);
  dispatch('invalidateSalesOrderList');
  dispatch('fetchSalesOrders')
}

const changeMode = function({commit}, mode){
  commit('SET_MODE',mode);
}

const setLoadingSalesOrder = function({commit}, loading){
  commit('SET_SALES_ORDER_LOADING', loading);
}

const setLoadingListSalesOrder = function({commit}, loading){
  commit('SET_LOADING', loading);
}

const updateSalesOrderPackage = function({ commit, state }, packageInfos) {
  console.log('PackageInfos ACTION : ', packageInfos);
  let index = -1;
  _.find(state.selectedSalesOrder.packages, (pack, idx) => {
    if (pack.id === packageInfos.id) {
      index = idx;
    }
  })
  commit('UPDATE_PACKAGE_INDEX', { index, packageInfos});
}

const downloadSalesOrderExcelExport = function({ state, getters }, filename) {
  let params = getters.fetchParams;
  params.format = 'EXCEL';
  delete(params.limit);
  return salesAPI.downloadTransactionSalesReport(getters.fetchParams, this.productName+'-commandes.xlsx')

}

export default {
  updateSalesOrderPackage,
  changeMode,
  fetchSalesOrders,
  setSearchTerms,
  selectSalesOrder,
  markAs,
  markAsConfirmed,
  markAsVoided,
  invalidateSalesOrderList,
  changeOrderBy,
  changeSortIcon,
  changePage,
  markAsInProcess,
  setSelectedSalesOrder,
  deleteSelectedSalesOrder,
  processSalesOrder,
  downloadSalesOrderReport,
  changeCustomerClassFilter,
  setStatusFilters,
  setDateFilters,
  setDeliveryDateFilters,
  resetFilters,
  updateCustomStatus,
  initSalesOrders,
  markAsDraft,
  setCheckedTagsFilter,
  returnAsConfirmed,
  setCheckedReps,
  setFilterWithoutReps,
  setProductFilter,
  setCustomerFilter,
  setDeliveryTypeFilter,
  setLoadingListSalesOrder,
  setLoadingSalesOrder,
  setInventoryFilter,
  fetchNextPage,
  fetchPreviousPage,
  confirmSAQ,
  downloadSalesOrderExcelExport,
  markAsCompleted,
};
